import { render, staticRenderFns } from "./KayakAdInline.vue?vue&type=template&id=18cefd10"
import script from "./KayakAdInline.vue?vue&type=script&lang=js"
export * from "./KayakAdInline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports